import { ref } from 'vue'

export default () => ({
  groups: ref([]),
  currentGroup: ref(null)
})
